import {Observable, of} from 'rxjs';
import {HttpHeaders} from '@angular/common/http';
import {SearchWithDtoResponse, Configuration, WhitepagesServiceInterface, SearchResponse} from '@gt-api';
import {Injectable} from '@angular/core';

@Injectable()
export class WhitepagesServiceStub implements WhitepagesServiceInterface {
  defaultHeaders: HttpHeaders = new HttpHeaders();
  configuration: Configuration;

  searchWithDto1(body?: string): Observable<SearchWithDtoResponse> {
    return undefined;
  }

  search1(query: string, format?: string): Observable<SearchResponse> {
    return of({
      code: 200,
      results: [
        '["vcard",[["version",{},"text","4.0"],["prodid",{},"text","ez-vcard 0.10.0"],["fn",{},"text","Gintel AS"],["n",{},' +
          '"text",["Gintel AS","","","",""]],["kid",{},"unknown",""],["idlinje",{},"unknown",' +
          '"D1E6CMP002|D1E6CMP003|D1E6CMP004|D1E6CMP005|D1E6CMP006|D1E6CMP007|D1E6CMP008|D1E6CMP009|D1E6CMP00A|D1E6CMP00B|D1E6CMP00C|' +
          'D1E6CMP00D"],["orgnr",{},"unknown","983953271"],["adr",{"type":"WORK"},"text",["Pb. 7004 Trondheim","","Otto Nielsens v 12",' +
          '"Trondheim","","7052",""]],["org",{},"text",["Gintel AS",""]],["tel",{"type":"WORK","pref":"1"},"text","+47 73 18 70 00"],' +
          '["tel",{"type":"WORK","pref":"1"},"text","+47 21 42 49 75"],["tel",{"type":"WORK","pref":"1"},"text","+47 73 18 70 00"],' +
          '["tel",{"type":"WORK","pref":"1"},"text","+47 73 50 36 15"],["tel",{"type":"WORK","pref":"1"},"text","+47 73 50 52 56"],' +
          '["tel",{"type":"CELL"},"text","+47 415 81 544"],["tel",{"type":"CELL"},"text","+47 459 64 650"],["tel",{"type":"CELL"},' +
          '"text","+47 479 12 974"],["tel",{"type":"CELL"},"text","+47 479 29 419"],["tel",{"type":"CELL"},"text","+47 479 29 497"],' +
          '["tel",{"type":"CELL"},"text","+47 483 11 198"],["tel",{"type":"CELL"},"text","+47 483 11 784"],["tel",{"type":"CELL"},' +
          '"text","+47 950 02 564"]]]'
      ]
    });
  }
}
